import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { deleteLoad } from 'apps/fleet-planner/utils/actions/loadDetails'
import { ConfirmationModal } from 'transfix-ui'
import { usePrevious } from 'utils/usePrevious'

interface IDeleteLoadModalProps {
  id?: string
  isFleet?: boolean
  showDeleteModal?: boolean
  saving?: boolean
  error?: string
}

export const DeleteLoadModal = memo<IDeleteLoadModalProps>(
  ({ error, id, isFleet, saving, showDeleteModal }) => {
    const history = useHistory()
    const dispatch = useDispatch()

    const onClose = (deleted: boolean) => {
      let { pathname } = history.location
      const regex = deleted ? /\/(\d+)\/delete$/i : /\/delete$/i
      if (!isFleet && deleted && !pathname.includes('/loads')) {
        pathname = pathname.replace(/\/load/i, '/loads')
      }
      history.push(pathname.replace(regex, ''))
    }

    const closeModalHandler = (action?: string) => {
      if (id && action === 'confirm') {
        dispatch(deleteLoad(id, isFleet))
      } else {
        onClose(false)
      }
    }

    const prevSaving = usePrevious(saving)
    useEffect(() => {
      if (showDeleteModal && prevSaving && !saving && !error) {
        onClose(true)
      }
    }, [saving])

    return (
      <ConfirmationModal
        title='Delete Load?'
        size={4}
        open={showDeleteModal}
        actions={[
          { label: 'Cancel', type: 'dismiss' },
          { label: 'Delete Load', type: 'confirm' },
        ]}
        onClose={closeModalHandler}
        dataTest='delete-load'
        error={error}>
        This action cannot be undone.
      </ConfirmationModal>
    )
  }
)
